import InputField from "../../../../common/InputField";
import React from "react";

const BankDetails = () =>{
    return (
        <div className="basic-details-wrapper">
            <h3>Bank Details</h3>
            <InputField
                name={['bank', 'accountName']}
                label={'Account Name'}
                isDisabled={true}
            />
            <InputField
                name={['bank', 'bank']}
                label={'Bank'}
                isDisabled={true}
            />
            <InputField
                name={['bank', 'branch']}
                label={'Branch'}
                isDisabled={true}
            />
            <InputField
                name={['bank', 'accountNumber']}
                label={'Account Number'}
                isDisabled={true}
            />
            <InputField
                name={['bank', 'branchCode']}
                label={'Branch Code'}
                isDisabled={true}
            />
            <InputField
                name={['bank', 'swiftCode']}
                label={'Swift Code'}
                isDisabled={true}
            />
        </div>
    );
};
export default BankDetails;